export const DEFAULT_STATE = {
    configs: null,
    statsDays: null,
    defaultChannel: null,
    silences: null,
    alerts: null,
    isLoadingConfigs: false,
    isLoadingSilences: false,
    isLoadingAlerts: false,
};
